const sessionIdValueGetter = (params) => params.data.util_sess_id;

export default sessionIdValueGetter;